import axios from 'axios';

const getActiveSession = async () => {
    const response = await axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/bills/v1/activeSessions/getActiveSession`);
    return response.data;
};

const getAllSessions = async () => {
    const response = await axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/sessions`);
    return response.data;
};

export { getActiveSession, getAllSessions };